import { combineReducers } from "redux";
import policyReducer from "./policy/policyReducer";
import accountReducer from "./account/accountReducer";
import layoutReducer from "./layout/layoutReducer";
import claimsReducer from "./claims/claimsReducer";
import healthInformationReducer from "./healthInformation/healthInformationReducer";
import networkStateReducer from "./networkStateReducer";
import exitSurveyReducer from "./exitsurvey/ExitSurveyReducer";
import makeAClaimReducer from "./makeAClaim/makeAClaimReducer";
import unreadMessagesReducer from "./inbox/unreadMessagesReducer";
import notificationsReducer from "./notifications/notificationsReducer";
import hbsReducer from "./hbs/hbsReducer";
import messageCentreReducer from "./messageCentre/MessageCentreReducer";
import { reducer as oidc } from "redux-oidc";
import navigationMenuReducer from "../components/navigation/reducers/navigationMenuReducer";
import loggedOutReducer from "../components/logout/loggedOutReducer";
import errorReducer from "./error/errorReducer";
import OIDCAccountReducer from "./account/OIDCAccountReducer";
import onboardingReducer from "../components/onboarding/onboardingReducer";
import { siteRedirectReducer } from "../components/navigation/reducers/siteRedirectReducer";
import { popupBlockerReducer } from "../features/popups/PopupBlockerReducer";
import preferenceReducer from "./policy/preferenceReducer";
import carouselReducer from "./Home/carouselReducer";
import preferenceConfirmReducer from "./policy/PreferenceConfirmReducer";

const allReducers = combineReducers({
  preferenceReducer,
  policyReducer,
  accountReducer,
  OIDCAccountReducer,
  layoutReducer,
  claimsReducer,
  healthInformationReducer,
  networkStateReducer,
  exitSurveyReducer,
  makeAClaimReducer,
  unreadMessagesReducer,
  notificationsReducer,
  hbsReducer,
  messageCentreReducer,
  oidc,
  navigationMenuReducer,
  loggedOutReducer,
  errorReducer,
  onboardingReducer,
  siteRedirectReducer,
  popupBlockerReducer,
  carouselReducer,
  preferenceConfirmReducer
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
    if (action.payload && action.payload.isTimedOut) {
      state = { accountReducer: { isTimedOut: true } };
    }
    if (action.payload && action.payload.systemUnavailable) {
      state = { networkStateReducer: { systemUnavailable: true } };
    }
  }

  return allReducers(state, action);
};

export default rootReducer;
